import type { PartDefinition, MaterialInfo } from '@rogue/rackbuilder'
import { AdjustOnlyVisual } from '../../../constants'
import type { SquatStandOptions } from '../../../RackTypes'
import { SquatStandBuilder } from '../squatStandBuilder'
import { getRackModel } from '../../../modelPaths'

export class SML2CSquatStand extends SquatStandBuilder {
  protected blackMaterial: MaterialInfo

  constructor(config: SquatStandOptions) {
    super(config)
    
    this.blackMaterial = this.createBlackMaterial()
  }

  protected createBlackMaterial(): MaterialInfo {
    return {
      main     : { name: 'metal', material: 'mg', color: 'black' },
      hardware : { material: this.hardware },
    }
  }

  /**
   * Override: SML-2C bases use black material instead of colored
   */
  protected createBase(left: boolean): PartDefinition {
    const base: PartDefinition = {
      mesh           : getRackModel('SML_COMMON_PARTS', 'base'),
      slots          : {},
      materials      : this.blackMaterial, 
      adjustments    : left ? [] : [{ type: 'flip', axis: 'Z' }],
      adjustmentType : left ? undefined : AdjustOnlyVisual,
    }

    if (left && this.bench) {
      base.slots.bench = this.bench
    }

    if (left) {
      base.slots['back-sticker'] = this.createBaseSticker()
    }

    return base
  }

  /**
   * Override: Back stabilizer uses black material
   */
  protected createBackStabilizer(): PartDefinition {
    return {
      mesh  : getRackModel('SML_COMMON_PARTS', 'back'),
      slots : {
        hardware: {
          mesh   : getRackModel('SML_COMMON_PARTS', 'stabilizer hardware'),
          slots  : {},
          anchor : 'back',
        },
      },
      materials: this.blackMaterial, 
    }
  }
}